// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"48413dfc","207":"0593f161"}[chunkId] + ".chunk.js";
};